import { render, staticRenderFns } from "./PaymentPopup.vue?vue&type=template&id=796f429a&scoped=true&"
import script from "./PaymentPopup.vue?vue&type=script&lang=js&"
export * from "./PaymentPopup.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPopup.vue?vue&type=style&index=0&id=796f429a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f429a",
  null
  
)

export default component.exports